import { Canvas } from "@react-three/fiber";
import { Planet } from "../components/Planet";
import { Environment, Float, Lightformer } from "@react-three/drei";
import { useMediaQuery } from "react-responsive";
import AnimatedHeaderSection from "../components/AnimatedHeaderSection";
import { socials } from "../constants";

const Hero = () => {
  const isMobile = useMediaQuery({ maxWidth: 853 });

  const text = `Full-Stack Software Engineer | AI Automation`;

  return (
    <section
      id="home"
      className="flex flex-col justify-end min-h-screen relative"
    >
      {/* TEXT CONTENT */}
      <div className="z-10 px-6 pb-20">
        <AnimatedHeaderSection
          subTitle={"firatolin.tech"}
          title={"Firatol Esayas"}
          text={text}
          textColor={"text-black"}
        />

        {/* CTA BUTTON (moved slightly up) */}
        <a
          href="/assets/cv/Firatol_Esayas_Tefera_CV.pdf"
          download
          className="inline-block mt-2 px-6 py-3 bg-black text-white rounded-full text-sm font-medium hover:bg-gray-800 transition"
        >
          Download CV
        </a>

        {/* SOCIAL ICONS (bigger + spaced) */}
        <div className="flex gap-8 mt-4">
          {socials.map((social, index) => {
            const Icon = social.icon;

            return (
              <a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
                className="text-black text-3xl hover:scale-110 transition-transform duration-200"
              >
                {Icon && <Icon />}
              </a>
            );
          })}
        </div>
      </div>

      {/* 3D BACKGROUND */}
      <figure
        className="absolute inset-0 -z-50"
        style={{ width: "100vw", height: "100vh" }}
      >
        <Canvas
          shadows
          camera={{ position: [0, 0, -10], fov: 17.5, near: 1, far: 20 }}
        >
          <ambientLight intensity={0.5} />

          <Float speed={0.5}>
            <Planet scale={isMobile ? 0.7 : 1} />
          </Float>

          <Environment resolution={256}>
            <group rotation={[-Math.PI / 3, 4, 1]}>
              <Lightformer
                form={"circle"}
                intensity={2}
                position={[0, 5, -9]}
                scale={10}
              />
              <Lightformer
                form={"circle"}
                intensity={2}
                position={[0, 3, 1]}
                scale={10}
              />
              <Lightformer
                form={"circle"}
                intensity={2}
                position={[-5, -1, -1]}
                scale={10}
              />
              <Lightformer
                form={"circle"}
                intensity={2}
                position={[10, 1, 0]}
                scale={16}
              />
            </group>
          </Environment>
        </Canvas>
      </figure>
    </section>
  );
};

export default Hero;
